/**
 * Nom d'une langue affichable à partir de son code (« ru » → « russe »), dans la
 * langue demandée. Repli sur le code brut si le code est inconnu ou si
 * Intl.DisplayNames ne sait pas le traduire.
 */
export function languageName(code: string, displayLanguage: string): string {
    try {
        return new Intl.DisplayNames([displayLanguage], { type: 'language' }).of(code) ?? code;
    } catch {
        return code;
    }
}
